/// <amd-module name="TFS/Admin/Groups/Common/Constants" />

export const groupsTab: string = "ms.vss-admin-web.org-admin-orggroups-groups-pivot";
export const usersTab: string = "ms.vss-admin-web.org-admin-orggroups-users-pivot";
export const servicePrincipalsTab: string = "ms.vss-admin-web.org-admin-orggroups-service-principals-pivot";
export const membersTab: string = "ms.vss-admin-web.org-admin-orggroups-members-pivot";
export const teamsTab: string = "ms.vss-admin-web.org-admin-teams-pivot";
export const permissionsTab: string = "ms.vss-admin-web.org-admin-orggroups-permissions-pivot";
export const groupMembersTab: string = "ms.vss-admin-web.org-admin-orggroups-group-members-pivot";
export const settingsTab: string = "ms.vss-admin-web.org-admin-orggroups-settings-pivot";
export const memberOfTab: string = "ms.vss-admin-web.org-admin-orggroups-memberof-pivot";

export const permissionsTabGroup: string = "ms.vss-admin-web.org-admin-permissions-hub-tabgroup";
export const groupsTabGroup: string = "ms.vss-admin-web.org-admin-permissions-hub-groupdetails-tabgroup";
export const usersTabGroup: string = "ms.vss-admin-web.org-admin-permissions-hub-userdetails-tabgroup";
export const memberOfTabGroup: string = "ms.vss-admin-web.org-admin-permissions-hub-memberofdetails-tabgroup";

export const GroupsPageTabGroup: string = "ms.vss-admin-web.org-admin-orggroups-hub-tabgroup";
export const TeamsPageTabGroup: string = "ms.vss-admin-web.org-admin-teams-hub-tabgroup";
export const GroupsPageDetailsTabGroup: string = "ms.vss-admin-web.org-admin-orggroups-hub-groupdetails-tabgroup";
export const UsersPageDetailsTabGroup: string = "ms.vss-admin-web.org-admin-orggroups-hub-userdetails-tabgroup";
export const TeamsPageDetailsTabGroup: string = "ms.vss-admin-web.org-admin-hub-teamsdetails-tabgroup";

export const SearchKeyword: string = "name";
export const IIdentityPickerHttpClient: string = "IIdentityPickerHttpClient";

export const IdentityNameSpaceId: string = "5a27515b-ccd7-42c9-84f1-54c998f03866";
export const IdentityPermissionsWrite: number = 2;
export const numberOfGroupsPerBatch = 50;

export const DeletedGroupSufix: string = "?groupDeleted=true";
export const GroupDeletedParam: string = "groupDeleted";
export const DisplayMaxMembersSize: number = 4;
export const TeamsMinAdminNumber: number = 1;
export const GroupNameMaxChar: number = 64;
export const GroupDescriptionMaxChar: number = 256;

export const ProjectSettingsRoute = "ms.vss-admin-web.project-admin-hub-route";
export const ProjectValidUsersWellKnownGroup = "Project Valid Users";
export const ContributorsWellKnownGroup = "Contributors";
export const PCAGroupName = "Project Collection Administrators";

export const searchTimeout = 350;

export namespace RouteParameters {
    export const AdminPivot = "adminPivot";
    export const Project = "project";
}

export namespace RouteValues {
    export const Notifications = "notifications";
    export const Dashboards = "dashboards";
    export const IterationAreaPaths = "work-team";
}

export namespace WellKnownGroupsSids {
    export const ProjectScopedUsers = "S-1-9-1551374245-1204400969-2402986413-2179408616-0-0-0-0-14";
    export const ProjectCollectionAdministrators = "S-1-9-1551374245-1204400969-2402986413-2179408616-0-0-0-0-1";
}

export enum IEntityType {
    User = "user",
    Group = "group",
    ServicePrincipal = "servicePrincipal",
    Team = "team"
}

export enum IPermissionPage {
    Organization = "Organization",
    Project = "Project",
    Teams = "Teams"
}

export enum GroupsColumns {
    MembersColumn = "members",
    TypeColumn = "type",
    ScopeColumn = "scope",
    NameColumn = "name"
}

export enum IOperationScope {
    /**
     *   Search the applicable source directory - AAD tenant-level for AAD-backed accounts or IMS account-level for MSA accounts/on-premise TFS
     **/
    Source = "source",
    /**
     *   Search IMS (Identity service)
     **/
    IMS = "ims",
    /**
     *   Search the Azure Active Directory
     **/
    AAD = "aad",
    /**
     *   Search Active Directory
     **/
    AD = "ad",
    /**
     *   Search Windows Machine Directory
     **/
    WMD = "wmd",
    /**
     *   Allows the selection of MSA users
     **/
    MSA = "msa"
}

export enum IReservedGroupNames {
    Global = "$NAMESPACE",
    AdministratorsGroup = "ADM:",
    ServiceUsersGroup = "SRV:",
    EveryoneGroup = "ALL:"
}

export enum IGroupDeletedValue {
    true = "true",
    false = "false"
}

export enum MembershipQuery {
    Direct = "Direct Members",
    Expanded = "Expanded Members"
}

export const enum GroupOperation {
    Add = 0,
    Delete = 1,
    Edit = 2,
    FetchGroups = 3,
    FetchMembership = 4,
    ListMemberships = 5,
    SetDefaultTeam = 6,
    CreateTeam = 7
}

export const enum PermissionChangeStatus {
    None = 0,
    InProgress = 1,
    Saved = 2,
    Error = 3
}

export const enum PermissionsContentType {
    Default = 0,
    Group = 1,
    User = 2,
    Permissions = 3,
    MemberOf = 4
}

export const enum PermissionsNavType {
    Default = 0,
    Group = 1,
    User = 2
}

export const enum MemberOperation {
    Add = 0,
    Delete = 1,
    Fetch = 2
}

export const enum SettingsOperation {
    DeleteGroup = 0,
    RemoveAdmin = 1,
    AddAdmins = 2
}

export const enum SearchStatus {
    None,
    Searching,
    Completed
}

export const enum GroupsNavType {
    Default = 0,
    GroupDetails = 1,
    UserDetails = 2,
    TeamDetails = 3,
    ServicePrincipalDetails = 4,
    MemberDetails = 5,
}

export const enum MemberOfOperation {
    Add = 0,
    Delete = 1,
    Fetch = 2
}

export const enum PermissionsOperation {
    Fetch = 0
}

export const teamImageUrl: string = "ms.vss-admin-web/admin-common-content/team.svg";
export const imageUrlPrefix: string = "data:image/png;base64,";
export const loadAADMembersFeatureFlag: string = "VisualStudio.Services.AdminEngagement.OrganizationPermissions.EnableLoadAADMembers";
export const disableMembersLoadingFeatureFlag: string = "VisualStudio.Services.AdminEngagement.Teams.DisableMembersLoading";
export const ProjectScopeUsersFeature: string = "ms.vss-admin-web.organization-admin-project-scope-users-group";
